export default __webpack_public_path__ + "static/media/SpringFestival_20.5557129e.png";